exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n._fc-validate .form-create .el-form-item {\r\n  margin-bottom: 22px !important;\n}\r\n", ""]);

// exports
